import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';

import { AuthService, ResolverLoadingService } from 'pbc.angular';

import { IFeldUnterkategoriesResponse } from 'fa-kt.types';
import { PostFeldUnterkategorieCommandService } from '../commands';
import { FeldUnterkategoriesService } from '../query';

@Injectable({
  providedIn: 'root',
})
export class FeldUnterkategoriesPageResolver implements Resolve<IFeldUnterkategoriesResponse | void> {
  constructor(
    private loading: ResolverLoadingService,
    private authService: AuthService,
    private feldUnterkategories: FeldUnterkategoriesService,
    private postFeldUnterkategorie: PostFeldUnterkategorieCommandService,
  ) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<IFeldUnterkategoriesResponse | void> {
    this.loading.resolving();
    const log = (error: any) => console.error(error);
    const [feldUnterkategories] = await Promise.all([this.feldUnterkategories.request({}).catch(log), this.postFeldUnterkategorie.prepare(true).catch(log)]);
    this.loading.resolved();
    return feldUnterkategories;
  }
}
